import { blinkerAnimation } from '@app/core/ui/animations';
import { Box } from '@mui/material';

interface LiveDotProps {
  /**
   * Color of the dot. Can be any valid CSS color value.
   * @default 'red'
   */
  color?: string;
  /**
   * Size of the dot in pixels.
   * @default 12
   */
  size?: number;
}

/**
 * A blinking dot indicator component typically used to show "live" status.
 * The dot pulses with a smooth animation and includes a glowing shadow effect.
 */
export function LiveDot({ color = 'red', size = 12 }: LiveDotProps) {
  // Convert color to rgba format for the shadow with alpha transparency
  // This creates a glowing effect around the dot
  const shadowColor = color === 'red' ? '#ff1744aa' : `${color}aa`; // Add alpha channel if not already present

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        boxShadow: `0 0 4px 2px ${shadowColor}`,
        animation: blinkerAnimation,
      }}
    />
  );
}
